// List-collections

function setCol(screenWidth) {
  const prodGrids = document.querySelectorAll("[data-prod-cols]");

  prodGrids.forEach((grid) => {
    const numCols = Number(grid.dataset.prodCols);
    if (screenWidth > 768 && screenWidth < 1024) {
      grid.style.gridTemplateColumns = `repeat(${numCols}, 31%)`;
    } else if (screenWidth > 1024) {
      grid.style.gridTemplateColumns = `repeat(${numCols}, 22.5%)`;
    }
  })
}



// set number of template columns when first load
const screenWidth = window.innerWidth;
setCol(screenWidth);



// dynamically changing the template columns for the grid when resize
window.addEventListener("resize", () => {
  const screenWidth = window.innerWidth;
  setCol(screenWidth)
})



// show hidden product grid in mobile version
const showHiddenButtons = document.querySelectorAll("[data-show-hidden-grid-btn]");

showHiddenButtons.forEach((button) => {
  button.addEventListener("click", () => {
    // get all the hidden product grids
    const hiddenGrids = button.closest("[data-prod-grid-wrapper]")
                              .querySelectorAll("[data-hidden-prod-grid]");

    // show all hidden grids after clicking
    hiddenGrids.forEach((grid) => {
      // unable to use data attribute as it will still hide the hidden product grid in larger screen (which is not desired)
      if (grid.classList.contains("hidden")) {
        grid.classList.remove('hidden');
      }
    })

    // hide the button after clicking
    if (button.dataset.showHiddenGridBtn == "show") {
      button.dataset.showHiddenGridBtn = "hidden";
    }
  })
})



// scroll the product grids
const scrollNextProdGridButtons = document.querySelectorAll("[data-next-prod-grid-btn]");

scrollNextProdGridButtons.forEach((button) => {
  button.addEventListener("click", () => {
    const lastProd = button.closest("[data-prod-grid-wrapper]")
                              .querySelector("[data-last-prod]");
    const scrollPrevProdGridButton = button.closest("[data-prod-grid-wrapper]")
                              .querySelector("[data-prev-prod-grid-btn]");
    const gridWrapper = button.closest("[data-prod-grid-wrapper]")
                              .querySelector("[data-prod-cols]");

    if (lastProd) {
      gridWrapper.style.paddingRight = "1rem";
      lastProd.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      button.style.opacity = "0";
      button.style.pointerEvents = "none";
      // show the prev button
      scrollPrevProdGridButton.style.opacity = "100";
      scrollPrevProdGridButton.style.pointerEvents = "auto";
    }
  })
})

const scrollPrevProdGridButtons = document.querySelectorAll("[data-prev-prod-grid-btn]");

scrollPrevProdGridButtons.forEach((button) => {
  button.addEventListener("click", () => {
    const firstProd = button.closest("[data-prod-grid-wrapper]")
                              .querySelector("[data-first-prod]");
    const scrollNextProdGridButton = button.closest("[data-prod-grid-wrapper]")
                              .querySelector("[data-next-prod-grid-btn]");
    const gridWrapper = button.closest("[data-prod-grid-wrapper]")
                              .querySelector("[data-prod-cols]");

    if (firstProd) {
      gridWrapper.style.paddingRight = 0;
      firstProd.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      button.style.opacity = "0";
      button.style.pointerEvents = "none";
      // show the prev button
      scrollNextProdGridButton.style.opacity = "100";
      scrollNextProdGridButton.style.pointerEvents = "auto";
    }
  })
})
